
export function formatCurrency(currencyString: any) {
  // Step 1: Check if currencyString is null or undefined
  if (!currencyString) {
      console.error('Invalid input: currencyString is null or undefined.');
      return null; // Return null if the input is invalid
  }

  // Step 2: Remove the currency symbol and any spaces
  const cleanString = currencyString.replace(/[^0-9.-]+/g, '');

  // Step 3: Convert the cleaned string to a number
  const numberValue = parseFloat(cleanString);

  // Step 4: Format the number back to currency
  const formattedCurrency = new Intl.NumberFormat('el-GR', {
      style: 'currency',
      currency: 'EUR',
  }).format(numberValue);

  return formattedCurrency; // Return only the formatted currency string
}

export const updateBodyClass = (className: string) => {
  document.body.className = ''; // Reset all body classes
  if (className) {
    document.body.classList.add(className);
  }
};
